<template>
	<div>
		<!-- <v-card-actions style="opacity:0">
			
			<v-spacer></v-spacer>	
			<v-btn color="warning" @click="downloadWithCSS">
				<v-icon>picture_as_pdf</v-icon> PDF
			</v-btn>

			<v-btn color="info" @click="exportTableToExcel('tblData', 'members-data')">
				<v-icon>description</v-icon> Excel
			</v-btn>
		</v-card-actions> -->

	<v-toolbar
		dark
		fixed
		app
		height="50"
		class="toolBar"
		>
		<v-spacer></v-spacer>

		<v-toolbar-items>
			<v-icon class="white--text" @click="downloadWithCSS('Quarterly-Progress-Repor')">cloud_download</v-icon>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<v-icon class="white--text" @click="printdiv">print</v-icon>
		</v-toolbar-items>
	</v-toolbar>


<!-- {{items}}
<br><br>
{{subItems}} -->

	<v-container grid-list-md :class="{opacityC:isTrue}">
		<v-layout wrap>
			<v-flex xs10 offset-xs1>
				<div style="background:#FFF; padding:20px;">
					<div ref="content" id="print_div">
						<table class="reportTbl" width="100%" id="tblData" >
							<tbody>
								<tr class="tb-td">
									<td colspan="9">Goverment of the Peoples's Republic of Bangladesh</td>
								</tr>
								<tr class="tb-td">
									<td colspan="9">Ministry of Planning</td>
								</tr>
								<tr class="tb-td">
									<td colspan="9"><u>Implementation Monitoring and Evaluation Division</u></td>
								</tr>
								<tr class="tb-td">
									<td colspan="9">Project Monitiring Form: IMED 03/2003 (Revised)</td>
								</tr>
								<tr class="tb-td">
									<td colspan="9">Quarterly Progress Report</td>
								</tr>
								<tr class="tb-td">
									<td colspan="9">Reporting Period : Up to</td>
								</tr>
								<tr class="tb-td">
									<td colspan="9">A.Quarterly Financial Progress Report</td>
								</tr>
								
								<tr  class="tb-td">
									<td colspan="9">&nbsp;</td>
								</tr>
								<tr>
									<td colspan="6" style="border:none">
										<table class="reportTbl" width="100%" >
											<tbody>
												<tr>
													<td rowspan="4">A.1</td>
													<td>a) Project Title</td>
													<td>
														{{items.project_name}}
														<!-- Investment Promotion &amp; Financing Facility I (IPFF I) Project --></td>
													</tr>
													<tr>
														<td>b) Ministry</td>
														<td>
															Finance Division, Ministry of Finanace
														</td>
													</tr>
													<tr>
														<td>C) Division</td>
														<td>
															{{items.Division_name}}
														</td>
													</tr>
													<tr>
														<td>d) Agency</td>
														<td>Bangladesh Bank</td>
													</tr>
													<tr>
														<td>A.2</td>
														<td colspan="2">Quarterly Fiancial Progress:</td>
													</tr>
												</tbody>
											</table>
										</td>
										<td colspan="3" style="border:none">
											<table class="reportTbl" width="100%" >
												<tbody>
													<tr>
														<td></td>
														<td>Project Code</td>
													</tr>
													<tr>
														<td>ADP</td>
														<td>{{items.adp_code}}</td>
													</tr>
													<tr>
														<td>Non</td>
														<td>{{items.non_adp_code}}</td>
													</tr>
												</tbody>
											</table>
										</td>
									</tr>
									<tr>
										<td style="border:none" colspan="9">&nbsp;</td>
									</tr>
									<tr class="txtCenter">
										<td rowspan="2">Head</td>
										<td colspan="2">Release for the Quarter</td>
										<td colspan="3">Expenditure for the Quarter</td>
										<td colspan="3">Current Year's Expenditure</td>
									</tr>
									<tr class="txtCenter">
										<td>GoB</td>
										<td>IDA</td>
										<td>IDA</td>
										<td>IDA</td>
										<td>DPA</td>
										<td>GoB</td>
										<td>IDA</td>
										<td>DPA</td>
									</tr>

									<tr v-for="sub in subItems">
										<td>{{sub.head_type}}</td>
										<td class="txtRight">{{sub.release_GOB}}</td>
										<td class="txtRight">{{sub.release_IDA}}</td>
										<td class="txtRight">{{sub.Expen_GOB}}</td>
										<td class="txtRight">{{sub.expens_IDA}}</td>
										<td class="txtRight">{{sub.expen_DPA}}</td>
										<td class="txtRight">{{sub.current_Expen_GOB}}</td>
										<td class="txtRight">{{sub.current_Expen_IDA}}</td>
										<td class="txtRight">{{sub.current_Expen_DPA}}</td>
									</tr>

								</tbody>
							</table>
						</div>
					</div>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas"
const commonService = require("../../../services/common.service");
export default {
	props:['paramVal'],
	data: () => ({
		items:'',
		subItems:[],	
		isTrue:false,	
	}),

	created(){
		this.getData();
	},

	watch: {
        paramVal() {
        	this.getData();
        }
    },

	methods: {

		getData(){
			let root = this
			let formSchema = '';
			let p = this.paramVal;
			
			if(typeof p == "undefined")
			{
				this.isTrue = false;
				formSchema = JSON.parse(sessionStorage.getItem('report'));
			}
			else
			{
				this.isTrue = true;
				formSchema = this.paramVal;
			}

			commonService.dataByMulParameters(formSchema, "quarterly-progress-report").then(res => {

				if(res)
				{
					if(res.mainQueryData.length>0)
					{
						this.items = res.mainQueryData[0]
					}

					if(res.querySub.length>0)
					{
						this.subItems = res.querySub
					}

					/*if(formSchema.report_type == 1)
					{
						this.downloadWithCSS('Quarterly-Progress-Repor');
					}*/
					if(formSchema.report_type == 0)
					{	
						setTimeout(function(){		
							root.exportTableToExcel('tblData', 'Quarterly-Progress-Repor');
						},1000);
					}
				}

			});
		},

		downloadWithCSS(filename = '') {			
			const doc = new jsPDF({
				orientation: "a4",
		        // unit: "pt",
		        format: [740, 1000]
		    });
			/** WITH CSS */
			var canvasElement = document.createElement('canvas');
			html2canvas(this.$refs.content, { canvas: canvasElement }).then(function (canvas) {
				const img = canvas.toDataURL("image/jpeg", 0.8);
				//doc.addImage(img,'JPEG',0,20);
				doc.addImage(img,'JPEG',6,10);
				filename = filename?filename+'.pdf':'pdf-file.pdf';
				doc.save("sample.pdf");
			});
		},

		exportTableToExcel: function(tableID, filename = ''){
			var downloadLink;
			var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename?filename+'.xls':'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if(navigator.msSaveOrOpenBlob){
				var blob = new Blob(['\ufeff', tableHTML], {
					type: dataType
				});
				navigator.msSaveOrOpenBlob( blob, filename);
			}else{
			// Create a link to the file
			downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

			// Setting the file name
			downloadLink.download = filename;

			//triggering the function
			downloadLink.click();
		}		
	},

	printdiv: function () {
                this.printContentStatus = true;
                const divToPrint = document.getElementById("print_div");
                this.printContentStatus = false;
                const newWin = window.open("", "Print-Window");
                newWin.document.open();
                newWin.document.write(
                    '<style type="text/css">'+
                    'table.reportTbl{width:100%;border-collapse:collapse}.reportTbl td{border:1px solid #ccc;padding:6px}.reportTbl tr td{text-align:left;line-height:12px}.txtRight{text-align:right!important}.reportTbl tr.txtCenter td{text-align:center}.reportTbl tr.tb-td td{font-weight:700;text-align:center;border:none}td.textCenter{text-align:center}td.textRight{text-align:right}'+
                    "</style>"
                );
                newWin.document.write(
                    '<html><head><link rel="stylesheet" href="src/assets/css/style.css" type="text/css" /></head><body onload="window.print()">' +
                    divToPrint.innerHTML +
                    "</body></html>"
                );

                newWin.document.close();
                setTimeout(function () {
                    newWin.close();
                }, 10);
            },

}
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table.reportTbl{
	width:100%;
	border-collapse: collapse;
}
.reportTbl td{
	border:1px solid #CCC;
	padding: 6px;
}
.reportTbl tr td{	
	text-align:left;
	line-height: 12px;
}
.txtRight{	
	text-align:right !important;
}
.reportTbl tr.txtCenter td{	
	text-align:center;
}
.reportTbl tr.tb-td td{
	font-weight: bold;
	text-align:center;
	border:none;
}
td.textCenter{
	text-align: center;
}
td.textRight{
	text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/reportGenerate/pdf/quarterlyProgressReport.vue